const Pagination = ({ pagination, page, onPageChange }) => {
  if (!pagination || pagination.totalPages <= 1) return null;

  const { totalPages } = pagination;
  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <div className="flex items-center justify-between mt-8 border-t border-divider pt-6">
      <button
        onClick={() => onPageChange(page - 1)}
        disabled={page === 1}
        className="h-9 px-4 border border-borderLight text-xs font-medium uppercase tracking-wide disabled:opacity-30 disabled:cursor-not-allowed hover:bg-surfaceAccentLight transition-colors"
      >
        ← Prev
      </button>

      <div className="flex items-center gap-1">
        {pages.map((p) => {
          const isActive = p === page;
          const isNearby = Math.abs(p - page) <= 2;
          const isEdge = p === 1 || p === totalPages;

          if (!isNearby && !isEdge) {
            if (p === 2 || p === totalPages - 1) {
              return (
                <span key={p} className="px-1 text-xs text-descriptionText">
                  …
                </span>
              );
            }
            return null;
          }

          return (
            <button
              key={p}
              onClick={() => onPageChange(p)}
              className={`h-9 min-w-[36px] px-2 border text-xs font-medium transition-colors ${
                isActive
                  ? "bg-primaryAccent text-white border-primaryAccent"
                  : "border-borderLight hover:bg-surfaceAccentLight text-headingText"
              }`}
            >
              {p}
            </button>
          );
        })}
      </div>

      <button
        onClick={() => onPageChange(page + 1)}
        disabled={page === totalPages}
        className="h-9 px-4 border border-borderLight text-xs font-medium uppercase tracking-wide disabled:opacity-30 disabled:cursor-not-allowed hover:bg-surfaceAccentLight transition-colors"
      >
        Next →
      </button>
    </div>
  );
};

export default Pagination;
